import { CoApplicantPipe } from '@hb/modules/global';
import { OwnPropertyPartStoreService } from '@hb/modules/extra-asset/own-property-part/own-property-part-store.service';
import { QuestionKey } from '@hb/modules/global/global.constants';
import { AmountFormControl } from '@hb/domain';
import { AnalyticsService } from '@hb/services/analytics/analytics.service';
import { AdditionalInfoComponent, NextButtonComponent } from '@hb/modules';
import { GLOBAL_STORE, GlobalInjectComponent, QUESTION_KEY } from '@hb/modules/global/abstract-global-inject.component';

import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApContentModule } from '@ap/content';
import { ApAmountInputComponent } from '@ap/input/amount';

@Component({
    selector: 'mortgage-amount',
    templateUrl: './mortgage-amount.component.html',
    standalone: true,
    imports: [ApContentModule, ReactiveFormsModule, ApAmountInputComponent, AdditionalInfoComponent, NextButtonComponent, CoApplicantPipe],
    providers: [
        { provide: GLOBAL_STORE, useExisting: OwnPropertyPartStoreService },
        { provide: QUESTION_KEY, useValue: QuestionKey.MORTGAGE_AMOUNT }
    ]
})
export class MortgageGlobalComponent extends GlobalInjectComponent<OwnPropertyPartStoreService> implements OnInit {
    private readonly analyticsService = inject(AnalyticsService);
    protected readonly store = inject(OwnPropertyPartStoreService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.mainApplicantControl = new AmountFormControl<string>(
            this.analyticsService,
            this.store.getMortgageAmount()?.amount.toString(),
            this.questionKey
        );
        this.mainApplicantControl.onUpdate().subscribe((amount) => this.store.setMortgageAmount(amount));
    }
}
